<template>
    <div class="api-logs-page">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{ $t('logsPage.logs') }}</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <div>
                            <div class="row">
                                <div class="col m-3">
                                    <el-popover
                                        placement="left"
                                        :title="$t('logsPage.filterLogs')"
                                        class="float-right"
                                        width="650"
                                        trigger="click">
                                        <base-button slot="reference" outline type="primary" class="filter-btn">
                                            <i class="m-0 ai ai-filter"></i>
                                            <i class="m-0 ai ai-angle-down"></i>
                                        </base-button>
                                        <el-form :model="filter" label-width="100px">
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-form-item :label="$t('general.user')">
                                                        <el-select v-model="filter.userId">
                                                            <el-option
                                                                :label="`-- ${$t('general.all')} --`"
                                                                :value="null"></el-option>
                                                            <el-option
                                                                v-for="user in users"
                                                                :key="user.id"
                                                                :label="user.name"
                                                                :value="user.id"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item :label="$t('general.hotel')">
                                                        <el-select v-model="filter.hotelId">
                                                            <el-option
                                                                :label="`-- ${$t('general.all')} --`"
                                                                :value="null"></el-option>
                                                            <el-option
                                                                v-for="hotel in hotels"
                                                                :key="hotel.id"
                                                                :label="hotel.name"
                                                                :value="hotel.id"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item :label="$tc('general.application', 1)">
                                                        <el-select v-model="filter.applicationId">
                                                            <el-option
                                                                :label="`-- ${$t('general.all')} --`"
                                                                :value="null"></el-option>
                                                            <el-option
                                                                v-for="app in applications"
                                                                :key="app.id"
                                                                :label="app.name"
                                                                :value="app.id"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item :label="$t('general.context')">
                                                        <el-input v-model="filter.context"></el-input>
                                                    </el-form-item>
                                                    <el-form-item :label="$t('general.message')">
                                                        <el-input v-model="filter.message"></el-input>
                                                    </el-form-item>
                                                    <el-form-item :label="$t('general.level')">
                                                        <el-select v-model="filter.level">
                                                            <el-option :label="`-- ${$t('general.all')} --`" :value="null"></el-option>
                                                            <el-option label="Info" value="info"></el-option>
                                                            <el-option label="Warning" value="warning"></el-option>
                                                            <el-option label="Error" value="error"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col>
                                                    <base-button
                                                        type="success"
                                                        class="float-right"
                                                        @click="updateLogs(true)">{{ $t('logsPage.applyFilters') }}
                                                    </base-button>
                                                </el-col>
                                            </el-row>
                                        </el-form>
                                    </el-popover>
                                </div>
                            </div>
                            <el-table class="table-responsive table-flush"
                                      header-row-class-name="thead-light"
                                      :data="logs"
                                      :empty-text="isLoadingLogs ? 'Loading...' : 'No Data'"
                                      lazy>

                                <el-table-column :label="$t('general.user')" sortable>
                                    <template v-slot="{row: log}">{{ log.user ? log.user.name : '' }}</template>
                                </el-table-column>

                                <el-table-column :label="$t('general.hotel')" sortable>
                                    <template v-slot="{row: log}">{{ log.hotel ? log.hotel.name : '' }}</template>
                                </el-table-column>

                                <el-table-column :label="$tc('general.application', 1)" sortable>
                                    <template v-slot="{row: log}">
                                        <el-tooltip
                                            v-if="log.application"
                                            class="item"
                                            effect="dark"
                                            :content="log.application.name"
                                            placement="top">
                                            <img
                                                :src="log.application.logo_url"
                                                :alt="log.application.name"
                                                class="app-icon">
                                        </el-tooltip>
                                    </template>
                                </el-table-column>

                                <el-table-column
                                    :label="$t('general.context')"
                                    prop="context"
                                    sortable/>

                                <el-table-column
                                    :label="$t('general.message')"
                                    prop="message"
                                    sortable/>

                                <el-table-column
                                    :label="$t('general.level')"
                                    prop="level"
                                    sortable/>

                                <el-table-column
                                    :label="$t('general.createdAt')"
                                    prop="created_at"
                                    sortable/>


                                <!--el-table-column
                                :label="$t('general.actions')"
                                class-name="actions-column"
                                width="100px">
                                    <template v-slot="{row}">
                                        <el-tooltip class="item" effect="dark" content="Edit user" placement="top">
                                            <router-link
                                                :to="'/users/' + row.id"><i class="ai ai-edit"></i>
                                            </router-link>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="Resend verification email"
                                            placement="top">
                                            <button
                                                type="button"
                                                v-if="!row.email_verified_at"
                                                @click="resendVerificationEmail(row)"><i class="ai ai-email"></i>
                                            </button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column-->
                            </el-table>

                            <div class="card-footer py-4 d-flex justify-content-center">
                                <el-pagination
                                    :total="logsCount"
                                    :current-page="currentPage"
                                    layout="prev, pager, next"
                                    background
                                    @current-change="pageChanged"></el-pagination>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import {Col, Form, FormItem, Option, Pagination, Popover, Row, Select, Table, TableColumn,} from 'element-ui'

    const actionNames = {
        index: 'Get',
        create: 'Created',
        store: 'Created',
        show: 'Get',
        edit: 'Edited',
        update: 'Updated',
        destroy: 'Deleted',
    }

    export default {
        components: {
            //LPagination,
            //LoadingSpinner,
            [Popover.name]: Popover,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Pagination.name]: Pagination,
            [Select.name]: Select,
            [Option.name]: Option,
            [Row.name]: Row,
            [Col.name]: Col,
        },
        data() {
            return {
                currentPage: 1,
                itemsPerPage: 10,
                pageCount: 0,
                isLoadingLogs: true,
                logs: [],
                logsCount: 0,
                users: [],
                hotels: [],
                applications: [],
                filter: {},
                filterString: '',
            }
        },
        methods: {
            async getLogs(query) {
                await this.$axios.get('/api/logs' + query)
                    .then(res => {
                        this.logsCount = parseInt(res.data.count);
                        // this.pageCount = Math.ceil(res.data / this.itemsPerPage);
                        this.logs = res.data.data;
                        this.isLoadingLogs = false;
                    })
                    .catch(err => {
                    })
            },
            async pageChanged(page) {
                this.filter.offset = (page - 1) * this.itemsPerPage;
                this.updateLogs();
            },
            updateLogs(clearOffset) {
                if (clearOffset) {
                    delete this.filter.offset;
                }

                const filterKeys = Object.keys(this.filter).filter(key => !!this.filter[key]);
                const queryString = filterKeys.map(key => key + '=' + this.filter[key]).join('&') || null;

                this.getLogs(queryString ? '?' + queryString : '');

                this.currentPage = 1;
            },
        },
        async created() {
            this.updateLogs(true);
            this.users = (await this.$axios.get('/api/users')).data.data;
            this.hotels = (await this.$axios.get('/api/profile')).data.data.hotels;
            this.applications = (await this.$axios.get('/api/applications')).data.data;
        },
    }

</script>
<style lang="scss">
    $unsortedColor: #c0c4cc;
    $sortedColor: #409eff;

    .api-logs-page {
        .app-icon {
            display: inline-block;
            width: 40px;
            height: 40px;
            object-fit: cover;
            object-position: center center;
        }
    }

    .card-header-data {
        display: inline-block;
    }

    .pagination {
        margin: auto;
    }

    .filter-btn {
        border: none;
        font-size: 18px;
        padding: 10px 14px;
        float: right;
        margin-bottom: 20px;
    }

    .el-popover__title {
        font-size: 18px;
    }

    .el-select {
        .el-input {
            &:hover {
                .el-input__icon,
                input {
                    color: initial !important;
                }
            }
        }
    }
</style>
